import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import { ActionConfig, IAction } from '../Action'

import { ActionContext } from '../Action'
import { DecisionStatusType } from 'Types/Tasks.types'

export class FinishTriagingAction implements IAction {
    static Id = 'FinishTriaging' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        const config = this.actionContext.studio.taskConfig
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'finish-triaging',
                title: this.config?.title ?? 'Finish Triaging',
                type: 'button',
                color: 'primary',
                disabled: this.config?.disabled ?? false,
                children: this.config?.children ?? [
                    {
                        id: 'accept',
                        title: 'Accept task',
                        icon: CheckCircleFilled,
                        iconColor: '#613889',
                        onClick: () => {
                            const errors =
                                this.actionContext.studio.inputManager.getViolationCount('error')
                            if (errors > 0) {
                                this.actionContext.modalManager?.showModal('violations-modal')
                                this.actionContext.task.ui?.updater.forceUpdate()
                                return
                            }

                            this.actionContext.task.taskState.setDecision({
                                status: DecisionStatusType.ACCEPT,
                                schema_version: 1,
                            })

                            const submitModalMetaData =
                                this.actionContext.modalManager?.getModalMetaData('submit-modal')
                            if (submitModalMetaData) {
                                this.actionContext.modalManager?.updateModalMetaData(
                                    'submit-modal',
                                    {
                                        isAccept: true,
                                        taskMode: config.mode,
                                    }
                                )
                            }
                            this.actionContext.modalManager?.showModal('submit-modal')
                        },
                    },
                    {
                        id: 'reject',
                        title: 'Reject task',
                        icon: CloseCircleFilled,
                        iconColor: '#E65048',
                        onClick: () => {
                            // TODO: to figure out analytics
                            if (
                                this.actionContext.modalManager?.getModalMetaData(
                                    'reject-or-skip-modal'
                                )
                            ) {
                                this.actionContext.modalManager?.updateModalMetaData(
                                    'reject-or-skip-modal',
                                    {
                                        isSkip: false,
                                        taskMode: config.mode,
                                    }
                                )
                            }
                            this.actionContext.modalManager?.showModal('reject-or-skip-modal')
                            this.actionContext.task.ui?.updater.forceUpdate()
                        },
                    },
                ],
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.removeAction('finish-triaging')
    }
}
